import styled from "styled-components";

export const Container = styled.h4`
  text-transform: capitalize;
  text-align: center;
`;
